module.exports = __webpack_public_path__ + "static/media/cresson.c2b211fd.svg";